import React from "react";

export const ProfessionalInfoStep = ({ formData, onChange, readOnly = false }) => (
  <React.Fragment>
    <div className="grid-item">
      <input
        name="affiliation"
        placeholder="Affiliation *"
        value={formData.affiliation}
        onChange={onChange}
        readOnly={readOnly}
        required
      />
    </div>
    <div className="grid-item">
      <input
        name="institution"
        placeholder="Institution or Hospital Name *"
        value={formData.institution}
        onChange={onChange}
        readOnly={readOnly}
        required
      />
    </div>
    <div className="grid-item">{/* Specialization field hidden as requested */}</div>
   
    <div className="grid-item grid-item--radio">
      <label className="radio-label">Do you have MCI Number?</label>
      <div className="radio-row">
        <label>
          <input
            type="radio"
            name="mciRegistered"
            value="Yes"
            checked={formData.mciRegistered === "Yes"}
            onChange={onChange}
            disabled={readOnly}
          />{" "}
          Yes
        </label>
        <label>
          <input
            type="radio"
            name="mciRegistered"
            value="No"
            checked={formData.mciRegistered === "No"}
            onChange={onChange}
            disabled={readOnly}
          />{" "}
          No
        </label>
      </div>
      {formData.mciRegistered === "Yes" && (
        <input
          name="mciNumber"
          placeholder="Enter MCI Number *"
          value={formData.mciNumber}
          onChange={onChange}
          readOnly={readOnly}
          required
        />
      )}
    </div>
  </React.Fragment>
);
